<template>
  <div class="downloads">
    <div class="downloads__item" :class="{'downloads__item--loading': clients_loading}">
      <div class="downloads__left">
        <img src="@/assets/img/downloads-pdf.svg" alt="Download">
        <div class="downloads__info">
          <button @click="onDownloadClients" class="downloads__name">Client’s details</button>
        </div>
      </div>
    </div>
    <div class="downloads__item" :class="{'downloads__item--loading': vouchers_loading}">
      <div class="downloads__left">
        <img src="@/assets/img/downloads-zip.svg" alt="Download">
        <div class="downloads__info">
          <button @click="onDownloadVouchers" class="downloads__name">Hotel vouchers</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSafariGroupVouchers, getSafariGroupListOfClients } from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'SafariGroupsDetailDownloads',
  props: {
    groupDetail: { Object }
  },
  data() {
    return {
      is_loaded: false,
      vouchers_loading: false,
      clients_loading: false,
    }
  },
  methods: {
    onDownloadVouchers() {
      this.vouchers_loading = true
      getSafariGroupVouchers(this.groupDetail.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.dateFormat(this.groupDetail.tour_start)} ${this.groupDetail.name} - Hotel vouchers.zip`)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          this.vouchers_loading = false
        })
    },
    onDownloadClients() {
      this.clients_loading = true
      getSafariGroupListOfClients(this.groupDetail.id)
        .then(response => {
          this.clients_loading = false
          window.open(response.data)
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
  }
}
</script>

<style scoped>

</style>
